export const categories = [
  { id: "shoes", name: "Shoes", description: "Latest sneakers & footwear finds", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { id: "hoodies", name: "Hoodies/Sweaters", description: "Cozy streetwear & premium hoodies", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" },
  { id: "tshirts", name: "T-Shirts", description: "Essential tees & graphic prints", url: "https://kaspreadsheet.com/category-913-T-Shirts.html" },
  { id: "jackets", name: "Jackets", description: "Bombers, denim & outerwear", url: "https://kaspreadsheet.com/category-914-Jackets.html" },
  { id: "pants", name: "Pants/Shorts", description: "Cargo, jeans & everyday bottoms", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html" },
  { id: "headwear", name: "Headwear", description: "Caps, beanies & bucket hats", url: "https://kaspreadsheet.com/category-916-Headwear.html" },
  { id: "sets", name: "Sets", description: "Coordinated tracksuits & matching sets", url: "https://kaspreadsheet.com/category-917-Sets.html" },
  { id: "underwear", name: "Underwear/Underpants", description: "Comfort essentials & basics", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html" },
  { id: "jersey", name: "Jersey", description: "Sports jerseys & athletic wear", url: "https://kaspreadsheet.com/category-919-Jersey.html" },
  { id: "accessories", name: "Accessories", description: "Watches, jewelry & extras", url: "https://kaspreadsheet.com/category-920-Accessories.html" },
  { id: "bags", name: "Bags", description: "Backpacks, totes & crossbody bags", url: "https://kaspreadsheet.com/category-921-Bags.html" },
  { id: "belts", name: "Belts", description: "Designer belts & accessories", url: "https://kaspreadsheet.com/search-922/name/Bags.html" },
  { id: "perfumes", name: "Perfumes", description: "Fragrances & colognes", url: "https://kaspreadsheet.com/search-923/name/Bags.html" },
  { id: "otherstuff", name: "Other Stuff", description: "Everything else you need", url: "https://kaspreadsheet.com/search-924/name/Bags.html" },
];

export const navButtons = [
  { label: "Acbuy Spreadsheet", url: "https://kaspreadsheet.com/" },
  { label: "Buy It Now", url: "https://kaspreadsheet.com/" },
];

export const trustData = [
  { value: "50,000+", label: "Monthly Users" },
  { value: "1,000+", label: "Curated Finds" },
  { value: "200+", label: "Trusted Sellers" },
  { value: "Weekly", label: "Updated Spreadsheet" },
];

export const whyChooseItems = [
  "Updated Weekly with Fresh Finds",
  "Verified Trusted Seller Lists",
  "Organized Fashion Categories",
  "Detailed Buying Guides",
  "Safety Information & Tips",
  "Beginner Friendly Interface",
];

export const faqItems = [
  {
    q: "What is AcBuySpreadsheet?",
    a: "AcBuySpreadsheet is a curated, regularly updated spreadsheet that lists trusted fashion sellers, verified product finds, and organized categories for sneakers, streetwear, hoodies, bags, and accessories. We help buyers discover reliable sources in one convenient place.",
  },
  {
    q: "How often is the spreadsheet updated?",
    a: "Our spreadsheet is updated weekly — every single week our editorial team reviews new sellers, removes outdated listings, and adds fresh finds across all categories including Shoes, Hoodies, T-Shirts, Jackets, and more.",
  },
  {
    q: "Is AcBuy safe to use?",
    a: "We take safety seriously. While no buying platform is 100% risk-free, our spreadsheet features only vetted and trusted sellers with proven track records. We also provide detailed safety guides, shipping tips, and buyer protection advice to help you shop with confidence.",
  },
  {
    q: "How do I find trusted sellers?",
    a: "Our spreadsheet organizes sellers by category and trust rating. Each seller listing includes verified reviews, shipping information, and community feedback. Simply browse your preferred category — whether Shoes, Jackets, or Accessories — and you will find our recommended trusted sellers at the top.",
  },
  {
    q: "Can beginners use AcBuy?",
    a: "Absolutely. AcBuySpreadsheet is designed with beginners in mind. We provide step-by-step buying guides, glossary of terms, shipping breakdowns, and everything a first-time buyer needs to navigate the fashion marketplace confidently.",
  },
  {
    q: "What products are included in the spreadsheet?",
    a: "Our spreadsheet covers 14 major categories: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff — essentially everything you need for a complete wardrobe update.",
  },
  {
    q: "Why should I use a spreadsheet instead of browsing directly?",
    a: "A spreadsheet saves you hours of searching. Instead of scrolling through thousands of unverified listings, you get a curated, organized view of the best finds, sorted by category, with seller ratings and direct links — all updated weekly.",
  },
  {
    q: "Is there a cost to use AcBuySpreadsheet?",
    a: "No. AcBuySpreadsheet is completely free to browse and use. Our goal is to help the fashion and streetwear community discover great products from trusted sellers without any subscription fees or hidden costs.",
  },
];

export const blogArticles = [
  {
    slug: "acbuy-spreadsheet-guide-2026",
    title: "Best AcBuy Spreadsheet 2026: Ultimate Buying Guide",
    excerpt: "Discover the most comprehensive AcBuy spreadsheet guide for 2026. We cover everything from trusted sellers, category breakdowns, safety tips, shipping guides, and how to find the best deals across all 14 product categories.",
    date: "June 2026",
  },
];